import script from "./DriverStatusView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriverStatusView.vue?vue&type=script&setup=true&lang=ts"

import "./DriverStatusView.vue?vue&type=style&index=0&id=49cc45b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cc45b9"]])

export default __exports__